import { ActionCreator, ActionType, on, ReducerTypes } from '@ngrx/store';
import produce from 'immer';

// https://gist.github.com/born2net/0a8e47a80e1e09fe984f57763680dc86?permalink_comment_id=3723301#gistcomment-3723301
export function produceOn<State, Creators extends ActionCreator>(
  creators: Creators,
  reducer: (state: State, action: ActionType<Creators>) => void,
): ReducerTypes<State, Creators[]> {
  return on(
    creators,
    (state, action) => produce(state, draft => reducer(draft as State, action)) as State,
  ) as unknown as ReducerTypes<State, Creators[]>;
}
